/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.geofences.internal

import features.geofences.models.GeofencesModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.geofences.internal.GeofencesUseCase.Params

internal class GeofencesUseCase : AsyncUseCase<GeofencesModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val pageNumber: Int,
        val perPage: Int
    )

    private val geofencesService: GeofencesService = GeofencesServiceImpl()

    override suspend fun run(params: Params): Result<GeofencesModel> {
        return geofencesService.getBusinessGeofences(
            overrideHeaders = params.overrideHeaders,
            pageNumber = params.pageNumber,
            perPage = params.perPage
        )
    }
}
